export const MTN_UG_REGEX = /^(?:\+?256|00256|0)?(?:7[678]|3[19])[0-9]{7}$/;
export const AIRTEL_UG_REGEX = /^(?:\+?256|00256|0)?(?:7[045]|20)[0-9]{7}$/;
export const UTL_UG_REGEX = /^(?:\+?256|00256|0)?(?:71|4[1-8])[0-9]{7}$/;
export const LYCA_UG_REGEX = /^(?:\+?256|00256|0)?72[0-9]{7}$/;
export const AFRICELL_UG_REGEX = /^(?:\+?256|00256|0)?79[0-9]{7}$/;
export const K2_UG_REGEX = /^(?:\+?256|00256|0)?73[0-9]{7}$/;

export const UG_MOBILE_PHONE_REGEX = /^(?:\+?256|00256|0)?7[0-9]{8}$/;
export const UG_FIXED_LINE_REGEX =
  /^(?:\+?256|00256|0)?(?:[34][0-9]|20)[0-9]{7}$/;
export const UG_TOLL_FREE_REGEX = /^(?:\+?256|00256|0)?800[0-9]{6}$/;
export const UG_PREMIUM_RATE_REGEX = /^(?:\+?256|00256|0)?90[0-9]{7}$/;

export const UG_PHONE_NUMBER_REGEX =
  /^(?:\+?256|00256|0)?(?:(?:7[0-9]|[34][0-9]|20|90)[0-9]{7}|800[0-9]{6})$/;

export const cleanUGPhoneNumber = (phoneNumber) => {
  if (typeof phoneNumber !== "string") return "";
  return phoneNumber.trim().replace(/[\s\-().]/g, "");
};

export const isUGPhoneNumber = (phoneNumber) => {
  if (typeof phoneNumber !== "string") return false;
  const cleaned = cleanUGPhoneNumber(phoneNumber);
  if (!cleaned) return false;
  return UG_PHONE_NUMBER_REGEX.test(cleaned);
};

export const DOMAIN_REGEX =
  /^(?:https?:\/\/)?(?:[a-zA-Z0-9_](?:[a-zA-Z0-9-_]{0,61}[a-zA-Z0-9_])?\.)+[a-zA-Z]{2,}(?::[0-9]{1,5})?(?:\/[^\s]*)?$/i;

export const isDomainName = (domain) => {
  if (typeof domain !== "string") return false;
  const trimmed = domain.trim();
  if (!trimmed) return false;
  if (/^[a-zA-Z0-9+.-]+:\/\//.test(trimmed) && !/^https?:\/\//i.test(trimmed)) {
    return false;
  }
  if (trimmed.startsWith("//")) {
    return false;
  }
  return DOMAIN_REGEX.test(trimmed);
};

export const EMAIL_REGEX = /^[\w\-\\.]+@([\w-]+\.)+[\w-]{2,}$/i;
// NETSERVE Uganda LIMITED
// KANJOKYA HOUSE
// 1. Application letter
// 2. Resume
// 3. Transcript

export const ANIMALS = [
  "Goats",
  "Sheep",
  "Cows",
  "Hens",
  "Donkeys",
  "Horses",
  "Rabbits",
];
export const CROPS = [
  "Rice",
  "Millet",
  "Beans",
  "Cassava",
  "Irish Potatoes",
  "Sweet Potatoes",
  "Yams",
];
